export const artworks = [
    {
        title: "Anmitsu",
        image: "gallery/p1.jpg",
    },
    {
        title: "Totoro Cream Puff",
        image: "gallery/p2.jpg",
    },
    {
        title: "Sukiyaki",
        image: "gallery/p3.jpg",
    },
    {
        title: "Ogura Toast",
        image: "gallery/p4.jpg",
    },
    {
        title: "Tempura",
        image: "gallery/p5.jpg",
    },
    {
        title: "Temari Candies",
        image: "gallery/p6.jpg",
    },
    {
        title: "Tamago Kaké Gohan",
        image: "gallery/p7.jpg",
    },
    {
        title: "Candied Strawberry",
        image: "gallery/p8.jpg",
    },
    {
        title: "Koi Komachi Dango",
        image: "gallery/p9.jpg",
    },
    {
        title: "Yakitori",
        image: "gallery/p10.jpg",
    },
];